<template>
  <div id="containerInfo">
    <div class="top_title">
      <span>{{$t('message.containerTitle')}}({{$t('message.GuiDangDingdan')}})</span>
      <div>
        <el-date-picker v-model="monthVal" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM" @change="monthChange" :editable="false"></el-date-picker>
        <el-select v-model="cityVal" @change="cityChange">
         <el-option  :label="$t('message.tokyoOffice')" value="東京"></el-option>
         <el-option  :label="$t('message.osakaOffice')" value="大阪"></el-option>
         <el-option  :label="$t('message.KWS1Office')" value="藤井寺"></el-option>
         <el-option  :label="$t('message.SWH7Office')" value="市川"></el-option>
        </el-select>
      </div>
	  <div class="noEnterContainersNum">{{$t('message.GuiDangDingdanBack')}}<img class="enterIcon" src="@/assets/queryIcon_blue.svg" @click="gohistoryContain" /></div>
    </div>
    <div class="dateBox">
      <div class="week" v-for="(week, index) in $t('message.week')">{{week}}</div>
      <div class="days" v-for="(day, index) in calendar" :key="index" @click="goCheckOrder(day.DaDate)">
        <span>{{day.Days}}</span>
        <div class="containerLabel" v-if="day.Lst.length !== 0">
          <div class="containerLabelTips" v-for="(info, idx) in day.Lst" :key="idx">
            <img class="containerIcon" src="@/assets/40GP_HQ.svg" v-if="info.Name === '40GP/HQ'" />
            <img class="containerIcon" src="@/assets/20GP_HQ.svg" v-if="info.Name === '20GP/HQ'" />
            <img class="containerIcon" src="@/assets/CFS.svg" v-if="info.Name === 'CFS'" />
            <img class="containerIcon" src="@/assets/NRT.svg" v-if="info.Name === 'NRT'" />
            <img class="containerIcon" src="@/assets/KIX.svg" v-if="info.Name === 'KIX'" />
            <img class="containerIcon" src="@/assets/HND.svg" v-if="info.Name === 'HND'" />
            <span>{{info.Num}}</span>
          </div>
        </div>
      </div>
      <div class="titleTipsBox">
        <div class="titleTips"><img class="labelIcon" src="@/assets/40GP_HQ.svg" /><span>40GP/HQ</span></div>
        <div class="titleTips"><img class="labelIcon" src="@/assets/20GP_HQ.svg" /><span>20GP/HQ</span></div>
        <div class="titleTips"><img class="labelIcon" src="@/assets/CFS.svg" /><span>CFS</span></div>
        <div class="titleTips"><img class="labelIcon" src="@/assets/NRT.svg" /><span>NRT</span></div>
        <div class="titleTips"><img class="labelIcon" src="@/assets/KIX.svg" /><span>KIX</span></div>
        <div class="titleTips"><img class="labelIcon" src="@/assets/HND.svg" /><span>HND</span></div>
      </div>
    </div>
    <el-dialog :title="$t('message.exportText')" :visible.sync="showExportDialog" destroy-on-close :close-on-click-modal="false" center>
      <div class="addBox">
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderCity')}}:</span>
          <el-checkbox-group v-model="exportCity">
            <el-checkbox label="東京">東京</el-checkbox>
            <el-checkbox label="大阪">大阪</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderModel')}}:</span>
          <el-checkbox-group v-model="exportContainerModel">
            <el-checkbox label="40GP/HQ">40GP/HQ</el-checkbox>
            <el-checkbox label="20GP/HQ">20GP/HQ</el-checkbox>
            <el-checkbox label="CFS">CFS</el-checkbox>
            <el-checkbox label="NRT" v-if="exportCity.indexOf('東京') >= 0">NRT</el-checkbox>
            <el-checkbox label="KIX" v-if="exportCity.indexOf('大阪') >= 0">KIX</el-checkbox>
            <el-checkbox label="HND" v-if="exportCity.indexOf('東京') >= 0">HND</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderArrivalDate')}}:</span>
          <el-date-picker
            v-model="exportDate"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('message.exportDatePlaceholder')"
            :end-placeholder="$t('message.exportDatePlaceholder')"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :clearable="false">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExportDialog = false">{{$t('message.cancleText')}}</el-button>
        <el-button type="primary" @click="confirmExport">{{$t('message.confirmText')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getContainerInfo, HTTPS } from '@/api/getDatahistory.js'
  export default {
    name: 'containerInfo',
    data () {
      return {
        monthVal: '', // 月份选择
        cityOptions: ['東京', '大阪'],
        cityVal: '東京',
        calendar: [],
        showExportDialog: false,
        exportCity: [],
        exportContainerModel: [],
        exportDate: [],
        noEnterContainersNum: 0
      }
    },
    created() {
      // this.cityVal = this.$store.state.cityVal || '東京'
      let param = this.$store.state.JHSS_containerInfo_param
      if (param.DADATE) {
        this.monthVal = param.DADATE
      } else {
        this.monthVal = this.getTime().month
      }
      if (param.CITY) this.cityVal = param.CITY
      this.getContainerInfo(param)
      this.noEnterContain()
    },
    methods: {
      // 当前月份
      getTime () {
        let date = new Date()
        let year = date.getFullYear()
        let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
        let obj = {
          year: year,
          month: year + '-' + month
        }
        return obj
      },
      // 月份选择
      monthChange (val) {
        this.monthVal = val
        this.getContainerInfo()
      },
      // 城市选择
      cityChange (val) {
        // this.$store.commit('setCityVal', val)
        this.cityVal = val
        this.getContainerInfo()
      },
      // 查询当前月集装箱信息
      async getContainerInfo () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { DADATE: this.monthVal, CITY: this.cityVal, ADDUSERID: this.$store.state.JHSS.personalUserid }
        let res = await getContainerInfo(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
           console.log("res.data",res.data)
          let date1 = new Date(res.data[0].DaDate)
          let day1 = date1.getDay() === 0 ? 7 : date1.getDay()
          let calendar = []
          for (let i = 0; i < day1 - 1; i++) {
            calendar.push({ DaDate: '', Days: '', Lst: [] })
          }
          calendar = calendar.concat(res.data)
          let date2 = new Date(res.data[res.data.length - 1].DaDate)
          let day2 = date2.getDay() === 0 ? 7 : date2.getDay()
          for (let j = 0; j < 7 - day2; j++) {
            calendar.push({ DaDate: '', Days: '', Lst: [] })
          }
          this.calendar = calendar
          console.log("calendar",calendar)
          this.$store.commit('setContainerInfoParam', param)
        }
      },
      // 进入下一级详细页面
      goCheckOrder (date) {
        if (!date) {
          return
        }
        this.$router.push({ path: '/containerOrderhistory', query: { date: date, city: this.cityVal } })
      },
      // 导出集装箱订单
      exportContainerOrders () {
        this.showExportDialog = true
        this.exportCity = []
        this.exportContainerModel = []
        this.exportDate = []
      },
      // 确定导出
      async confirmExport () {
        if (this.exportCity.length === 0) {
          this.$message(this.$t('message.exportDatePlaceholder') + this.$t('message.containerOrderCity'))
        } else if (this.exportContainerModel.length === 0) {
          this.$message(this.$t('message.exportDatePlaceholder') + this.$t('message.containerOrderModel'))
        } else if (this.exportDate.length === 0) {
          this.$message(this.$t('message.exportDatePlaceholder') + this.$t('message.containerOrderArrivalDate'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = { CITY: this.exportCity.join(','), JZXSIZE: this.exportContainerModel.join(','), UDADATE: this.exportDate[0], DDADATE: this.exportDate[1], ADDUSERID: this.$store.state.JHSS.personalUserid }
          let res = await exportContainerOrder(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else {
            // console.log(res.data)
            let str = HTTPS + "/xlsx/" + res.data
            window.open(str)
            this.showExportDialog = false
          }
        }
      },
	  gohistoryContain (){
        this.$router.push({ path: '/containerInfo' })
	  }
    }
  }
</script>

<style scoped>
#containerInfo {
  width: 100%;
  height: 100%;
}
.top_title {
  width: 100%;
  height: 86px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px 0 45px;
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(203,203,203,0.50);
  border-radius: 2px 0;
  font-size: 20px;
  color: #333333;
}
.noEnterContainersNum {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  color: #666666;
}
.enterIcon {
  margin-left: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.dateBox {
  width: 100%;
  height: calc(100% - 86px);
  height: -moz-calc(100% - 86px);
  height: -webkit-calc(100% - 86px);
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(203,203,203,0.50);
  border-radius: 0 2px;
  padding: 36px 65px 0;
  overflow-y: scroll;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.dateBox::-webkit-scrollbar { width: 0 !important; }
.dateBox { /* -ms-overflow-style: none; */ -ms-overflow-x: unset; }
.dateBox { overflow: -moz-hidden-unscrollable; }
.week {
  flex-shrink: 0;
  width: 14.28%;
  height: 54px;
  background: #EEF0F5;
  font-size: 18px;
  color: #333333;
  line-height: 54px;
  border: 1px solid #FFFFFF;
  border-radius: 8px 8px 0 0;
}
.days {
  flex-shrink: 0;
  width: 14.28%;
  height: 147px;
  background: #FFFFFF;
  font-size: 36px;
  color: #333333;
  line-height: 42px;
  border: 1px solid #EEF0F5;
  padding: 28px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
}
.containerLabel {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  /* padding: 0 19px; */
}
.containerLabelTips {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #666666;
}
.containerIcon {
  flex-shrink: 0;
  width: 22.5px;
  height: 22.5px;
  margin-right: 8rpx;
}
.titleTipsBox {
  flex-shrink: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.titleTips {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 44px;
  font-size: 18px;
  color: #333333;
}
.labelIcon {
  flex-shrink: 0;
  width: 22.5px;
  height: 22.5px;
  margin-right: 21px;
}
/* 订单弹窗 */
/deep/ .el-dialog__header {
  background: #0066FF;
}
/deep/ .el-dialog__title, /deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
.addLine {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: nowrap;
  margin-top: 10px;
  min-height: 50px;
}
.addItemTitle {
  flex-shrink: 0;
  width: 200px;
  font-size: 18px;
  color: #333333;
  margin-right: 10px;
  text-align: right;
  word-break: keep-all;
}
</style>
